module.exports = __webpack_public_path__ + "img/puzzle_35.cf142cc5.png";